/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';

import styles from './SalesProspectingLeadGenerationTerms.module.scss';

type Translate = (key: string) => string;

type Term = {
  title: string;
  description: string;
};

const getTerms = (t: Translate): Term[] => [
  {
    title: t('Field-level provenance'),
    description: t(
      'Every attribute carries the registry it came from and the date it was retrieved. Nothing in the export is unattributed.',
    ),
  },
  {
    title: t('Open identifiers'),
    description: t(
      'Company numbers, VAT numbers and LEIs travel with the record. No proprietary key that only resolves inside our platform.',
    ),
  },
  {
    title: t('Redistribution rights'),
    description: t(
      'Bulk export, internal redistribution and downstream use are covered by the licence, including AI training terms where agreed.',
    ),
  },
];

export const SalesProspectingLeadGenerationTerms = () => {
  const { t } = useInt();
  const terms = getTerms(t);

  return (
    <section className={styles.section}>
      <div className={styles.glow} aria-hidden="true" />

      <div className={styles.container}>
        <div className={styles.marker}>
          <span className={styles.markerNum}>03</span> / {t('Terms')}
        </div>

        <div className={styles.body}>
          <div className={styles.head}>
            <TitleBlock
              align="left"
              theme="dark"
              title={t('Data you can keep, use and defend')}
              description={t(
                'Every enterprise deal reaches the point where procurement asks where the data came from and legal asks what you are allowed to do with it. Both answers are below, and both are in the contract.',
              )}
            />
          </div>

          <div className={styles.grid}>
            {terms.map((term) => (
              <div key={term.title} className={styles.cell}>
                <h4>{term.title}</h4>
                <p>{term.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
